/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Cli_AcInputs */

const en_pc_cmp_r_cli_ac = /** @type {(inputs: Pc_Cmp_R_Cli_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action Wizard in Pro, cloud APIs sold separately`)
};

const zh_pc_cmp_r_cli_ac = /** @type {(inputs: Pc_Cmp_R_Cli_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro 版提供 Action Wizard，云 API 需单独购买`)
};

/**
* | output |
* | --- |
* | "Action Wizard in Pro, cloud APIs sold separately" |
*
* @param {Pc_Cmp_R_Cli_AcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_cli_ac = /** @type {((inputs?: Pc_Cmp_R_Cli_AcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Cli_AcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_cli_ac(inputs)
	return zh_pc_cmp_r_cli_ac(inputs)
});
export { pc_cmp_r_cli_ac as "pc.cmp.r.cli.ac" }